export default {
    name: "myAccount",
    data:function () {
        return{
            info:{},
            billList:[]
        }
    },
    methods:{
        getInfo:function () {
            var _this=this;
            this.$post("/customerservicemanager/accountinfo",function (res) {
                if(res.Success){
                    _this.info=res.Result;
                }else{
                    _this.$toast(res.Message);
                }
            });
        },
      getBills:function () {
          var _this=this;
          this.$post("/customerservicemanager/mybill",{
            "Page": 1,
            "Length": 10
          },function (res) {
            if(res.Success && res.Result){
              _this.billList=res.Result.ListBill;
            }else{
              _this.$toast(res.Message);
            }
          });
        },
      viewJob: function(bill) {
        this.$router.push({name:"jobDetail", query:{id: bill.JobId}})
      },
      go2pay: function() {
        this.$router.push({name:"payBalance"});
      },
      go2PayDeposit: function() {
        this.$router.push({name:'payDeposit'});
      }
    },
    mounted:function () {
        this.getInfo();
        this.getBills();
    },
    watch: {
      '$route': function (to, from) {
        if (to && to.name === 'myAccount'){
          this.getInfo();
          this.getBills();
        }
      }
    }
}



// WEBPACK FOOTER //
// ./src/ally/page/myAccount.js